import jsCookie from 'js-cookie';

const getBrowserCookie = (...args) => {
  return jsCookie.get(...args);
};

const setBrowserCookie = (...args) => {
  return jsCookie.set(...args);
};

const setIsFavoritesRequiredToReload = (value = true) => {
  setBrowserCookie('isFavoritesRequiredToReload', value, {
    expires: 1,
    domain: '.hepsiburada.com'
  });
};

export { setIsFavoritesRequiredToReload, getBrowserCookie };
